import type { Selection } from '../model/models';

function countSelectedWeightClasses(selectedList: Selection) {
  return Object.values(selectedList.weights).filter((value) => value > 0)
    .length;
}

export { countSelectedWeightClasses };
